import { Component, OnInit } from '@angular/core';
import { CustomerModel } from 'src/app/models/customer-model';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { WebservicesService } from 'src/app/services/webservices/webservices.service';
import { PopoverController } from '@ionic/angular';
import { Navigator } from '../../menu/navigator';
import { UtilsService } from 'src/app/services/utils/utils.service';
import gsap from "gsap";
import { BonusContent } from 'src/app/popovers/bonus-content/bonus-content.page';
import { Subject, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';
import { EventsService } from 'src/app/services/event/event.service';

@Component({
  selector: 'app-footer-next-bonus',
  templateUrl: './footer-next-bonus.component.html',
  styleUrls: ['./footer-next-bonus.component.scss'],
})
export class FooterNextBonusComponent implements OnInit {

  protected timeLeft: number = undefined;
  protected enabled: boolean = false;
  public customerId: number;
  protected hourlyBonusSec: number = undefined;
  private boxCounter: number = 1;
  private autoHideCount: number = 6000;
  private customerSubscription: Subscription | null = null;
  private destroy$ = new Subject<void>();
  protected intervalId;

  constructor(
    private webservices: WebservicesService,
    private userSession: UserSessionService,
    private config: ConfigService,
    public utilsService: UtilsService,
    public balanceProvider: AccountBalanceService,
    public popoverController: PopoverController,
    private readonly navigator: Navigator,
    private readonly events: EventsService
  ) {
  }

  ngOnInit() {
    this.config.isLoaded().then((config) => {
      this.isUserLoggedIn();
      //this.userSession.getCustomerSubscription();
      this.hourlyBonusSec = this.config.getConfig()['FEATURE_MHB_PERIOD_SECS'] ?? 10800; // by default it setting for 3 hours
      this.autoHideCount = this.config.getConfig()['FEATURE_AUTO_HIDE_SECS'] ?? 15000 // by default set to 6 seconds
    });
    this.checkAppState();
  }

  ngOnDestroy() {
    this.clearatimeIntervals();
    this.events.destroy('event:appStateChange');
  }

  checkAppState() {
    this.events.subscribe('event:appStateChange', (isActive) => {
      this.clearatimeIntervals();
      if (isActive) {
        this.checkUser(this.customerId);
      } else {
        this.enabled = false;
      }
    });
  }

  protected isUserLoggedIn() {
    this.customerSubscription?.unsubscribe();
    this.userSession.getCustomerSubscription().then((obs) => {
      this.customerSubscription = obs
        .pipe(
          takeUntil(this.destroy$),
          filter((customer) => !!customer),
          map((customer) => customer.customerId),
          distinctUntilChanged()
        )
        .subscribe((customerId) => {
          this.checkUser(customerId);
        });
    });
  }

  checkUser(customerId) {
    if (customerId) {
      this.customerId = customerId;
      this.startCountdown("next-hourly-bonus");
    } else {
      this.enabled = false;
    }
  }

  protected startCountdown(urlCheck) {
    return new Promise((resolve, reject) => {
      this.userSession.isAuthenticated().then((res) => {
        if (res) {
          this.webservices.get(`bonus/${urlCheck}`, {
            customer_id: this.customerId,
            session_token: this.userSession?.sessionToken
          }).subscribe((res) => {
            if (res.result) {
              this.enabled = true;
              this.setTimeLeft(res.payload.seconds_remaining)
              this.applyAnimationDuration((this.hourlyBonusSec - res.payload.seconds_remaining) - 5);
              resolve(res.payload);
            } else {
              this.enabled = false;
              resolve(null);
            }
          }, (error) => {
            this.enabled = false;
            reject(error);
          });
        } else {
          this.enabled = false;
          resolve(null);
        }
      });
    });
  }

  protected setTimeLeft(timeLeft: number) {
    this.timeLeft = timeLeft;
    this.intervalId = setInterval(() => {
      if (this.timeLeft - 1 >= 0) {
        this.timeLeft -= 1;
      } else {
        this.clearatimeIntervals();
      }
    }, 1000);
  }

  protected clearatimeIntervals() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  isAuthenticated(): any {
    return this.userSession.isAuthenticated();
  }

  isBonusAvailable(): any {
    return this.timeLeft <= 0;
  }

  protected isCollectBonusClicked: boolean = false
  async onGetBonus() {
    try {
      if (!this.isCollectBonusClicked) {
        this.isCollectBonusClicked = true;
        this.clearatimeIntervals();
        const isBonusResonse: any = await this.startCountdown("get-hourly-bonus");
        if (isBonusResonse && isBonusResonse.spin_grant) {
          setTimeout(() => {
            const data: BonusContent = {
              isAutoHideEnabled: true,
              isAutoHideTimeout: this.autoHideCount,
              amount: isBonusResonse.spin_grant,
              istopLeft: true,
            }
            const popoverComp = 'BonusContentPage';
            this.navigator.openPopover(popoverComp, data, "auto-dismiss-popover", true, true, true, -1, 'cover', false);
            this.balanceProvider.updateBalance();
            this.isCollectBonusClicked = false;
          }, 1500);
        }else {
          this.isCollectBonusClicked = false;
        }
      }
    } catch (error) {
      this.isCollectBonusClicked = false;
      console.log("error calling onGetBonus ", error)
    }
  }

  // progress svg animation control
  applyAnimationDuration(remianing) {
    this.enabled = true;
    setTimeout(() => {
      const svg: any = document.getElementById("hbtn");
      if (svg) {
        let combinedStyles = `animation: ${this.hourlyBonusSec}s linear infinite both a0_t, ${this.hourlyBonusSec}s linear infinite both a0_d;`;
        const maskElements = svg.querySelector("#Mask-1 path");
        const negativeDelay = -remianing;
        if (maskElements) {
          maskElements.setAttribute("style", combinedStyles);
          maskElements.style.animationDelay = `${negativeDelay}s`;
          // maskElements.style.animationDelay = `${Math.max(negativeDelay, 0)}s`;
          // Create a new <animate> element
          const animateElement = document.createElementNS('http://www.w3.org/2000/svg', 'animate');
          animateElement.setAttribute('attributeName', 'd');
          animateElement.setAttribute('dur', `${this.hourlyBonusSec}s`);
          animateElement.setAttribute('values', 'M0,-42L0,93L98,93L0,93.9Z;M0,-42L22,24L98,93L0,93.9Z;M0,-42L70,-9L98,93L0,93.9Z;M0,-42L205,33L98,93L0,93.9Z');
          animateElement.setAttribute('keyTimes', '0;0.2;0.4;1');
          animateElement.setAttribute("begin", `${negativeDelay}s`);
          maskElements.appendChild(animateElement);
        }
      }
    }, 600);
  }
}
